import { createContext, useContext } from 'react';

var ClientContext = /*#__PURE__*/ createContext(undefined);
var useClientContext = function() {
    var context = useContext(ClientContext);
    if (!context) {
        throw new Error("ClientProvider is not in the render tree");
    }
    return context;
};

export { ClientContext, useClientContext };
